/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
`;

export const VideoContainer = styled.div`
  height: 82vh;
  align-items: center;
  justify-content: center;
  @media only screen and (max-width: 414px) {
    height: 32vh;
  }

  @media only screen and (max-width: 800px) {
    height: 40vh;
  }
`;
